import { ReactNode } from "react";
import style from "./CommonPopup.module.css";

function CommonPopup(props: {
    active: boolean;
    zIndex?: number;
    children?: ReactNode;
}) {
    return (
        <div className={style["popup-root"]} style={{ zIndex: props.zIndex || 9999 }}>
            <div className={[style["popup-content"], props.active ? style['active'] : null].join(' ')}>
                {props.children}
            </div>
        </div>
    );
}
export default CommonPopup;